import { FC, useContext } from 'react';
import styled from 'styled-components';
import { DetectedFace, DetectedOriginal, Swap } from '../ApiTypes';
import { getFaceCroppedSrc, getSwapThumbnailUrl } from '../Storage';
import { UserStateContext } from '../contexts/UserStateContext';

const FACE_RATIO = 0.28;

const SourceContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  background-color: #1f1f1f;
`;

const OriginalImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

// 右下に重なる顔写真を読みやすくするための影。
const Shade = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at 100% 100%, rgba(0, 0, 0, 0.55) 0%, transparent 60%);
`;

const FaceImg = styled.img`
  display: block;
  position: absolute;
  right: 5%;
  bottom: 7%;
  width: ${FACE_RATIO * 100}%;
  aspect-ratio: 1;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.85);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
`;

const SourceView: FC<{ original?: DetectedOriginal, face?: DetectedFace, swap?: Swap }> = (props) => {
  const userState = useContext(UserStateContext);

  const thumbnailUrl = props.swap && userState.userId
    ? getSwapThumbnailUrl(userState.userId, props.swap.swapId)
    : props.original?.detected.imageUrl;

  return <SourceContainer>
    {thumbnailUrl && <OriginalImg src={thumbnailUrl} alt={props.original?.detected.title ?? ''} loading="lazy" />}
    <Shade />
    {props.face && <FaceImg src={getFaceCroppedSrc(props.face)} alt="" loading="lazy" />}
  </SourceContainer>
};

export default SourceView;
